import { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Container, Modal, Row } from "react-bootstrap";
import Draggable from "react-draggable";
import { Link, useHistory } from "react-router-dom";
import { DataStoreContext } from "../DataStore/DataStore";
import { sendSocket } from "../Socket/SocketManager";

export var gameStateSetter: any;
export var gameEnemyDisconnectedMsgSetter: any;

export const GamePage: React.FC = () => {

  const dataStore = useContext(DataStoreContext);

  const [gameState, setGameState] = useState<any | undefined>(undefined);
  gameStateSetter = setGameState;

  const [gameEnemyDisconnectedMsg, setGameEnemyDisconnectedMsg] = useState<string | undefined>(undefined);
  gameEnemyDisconnectedMsgSetter = setGameEnemyDisconnectedMsg;

  const history = useHistory();

  useEffect(() => {

    if (dataStore.game.waitingForPlayer) return;
    if (dataStore.game.gameActive) return;

    history.replace("/");

  }, []);

  return (
    <>
      <GameEndModal visible={gameEnemyDisconnectedMsg !== undefined} msg={gameEnemyDisconnectedMsg + ""} />
      {(dataStore.game.waitingForPlayer) && <GameInviteContent
        otherUsername={dataStore.game.inviteUsername + ""}
        failed={dataStore.game.inviteFailed}
      />}
      {(dataStore.game.gameActive) && <GameContent gameState={gameState} />}
    </>
  );
}

interface GameInviteContentProps {
  otherUsername: string;
  failed: boolean;
}

const GameInviteContent: React.FC<GameInviteContentProps> = ({ otherUsername, failed }) => {
  return (
    <>
      <br /><br /><br />
      {(!failed) ? <>
        <h1 className="text-info text-center" style={{ fontSize: 80 }}>waiting for {otherUsername}</h1>
        <h1 className="text-info text-center">to accept your invite</h1>
      </> : <>
        <h1 className="text-danger text-center" style={{ fontSize: 120 }}>invite failed</h1>
        <h2 className="text-info text-center">{otherUsername} has disconnected</h2>
        <br /><br />
        <div className="text-center">
          <Button as={Link} to="/">back to main page</Button>
        </div>
      </>}
    </>
  );
}

interface GameContentProps {
  gameState: any;
}

const GameContent: React.FC<GameContentProps> = ({ gameState }) => {

  const [updateDropPosition, setUpdateDropPosition] = useState<boolean>(true);

  const [drop1, setDrop1] = useState<any | undefined>(undefined);
  const [drop2, setDrop2] = useState<any | undefined>(undefined);
  const [drop3, setDrop3] = useState<any | undefined>(undefined);
  const [drop4, setDrop4] = useState<any | undefined>(undefined);
  const [drop5, setDrop5] = useState<any | undefined>(undefined);
  const [drop6, setDrop6] = useState<any | undefined>(undefined);
  const [drop7, setDrop7] = useState<any | undefined>(undefined);
  const [drop8, setDrop8] = useState<any | undefined>(undefined);
  const [drop9, setDrop9] = useState<any | undefined>(undefined);

  const [tokenDisabled, setTokenDisabled] = useState<any | undefined>(undefined);

  useEffect(() => {

    if (updateDropPosition) setUpdateDropPosition(false);

  }, [updateDropPosition]);

  useEffect(() => {

    if (gameState === undefined || gameState.availableTokens === undefined) {
      setTokenDisabled([
        true, true, true,
        true, true, true,
        true, true, true
      ]);
      return;
    }

    setTokenDisabled(gameState.availableTokens.map((b: boolean) => !b));

  }, [gameState]);

  function evalDrop(x: number, y: number, id: number) {

    [drop1, drop2, drop3, drop4, drop5, drop6, drop7, drop8, drop9].forEach(e => {
      if (x < e.x - 10 || x > e.x2 + 10 || y < e.y - 10 || y > e.y2 + 10) return;
      placeAction(id, e.id);
      setTokenDisabled([
        ...tokenDisabled.slice(0, id - 1),
        true,
        ...tokenDisabled.slice(id)
      ]);
    });

  }

  function placeAction(tokenId: number, positionId: number) {

    console.log("[HIT]: token:" + tokenId + " | pos:" + positionId); // TODO: remove DEBUG

    sendSocket("game-place-action", {
      tokenId: tokenId,
      positionId: positionId
    });

  }

  return (
    <>
      <br /><br />
      <Container fluid>
        <Row>
          <Col xs={0} md={1} lg={2} />
          <Col xs={12} md={10} lg={8} >
            <h2 className="text-info text-center">
              playing against {(gameState !== undefined && gameState.enemyName !== undefined) ? gameState.enemyName : "..."}
            </h2>
            <br />
            <div className="text-center">
              <svg width="300" height="300" style={{ transform: "scale(1.1)", marginTop: 35, marginBottom: 95 }}>
                <line strokeWidth="10" y2="300" x2="100" y1="0" x1="100" stroke="#0c4f5a" />
                <line strokeWidth="10" y2="300" x2="200" y1="0" x1="200" stroke="#0c4f5a" />
                <line strokeWidth="10" y2="100" x2="300" y1="100" x1="0" stroke="#0c4f5a" />
                <line strokeWidth="10" y2="200" x2="300" y1="200" x1="0" stroke="#0c4f5a" />
                <Token x={50} y={50} n={0} dropDataSetter={setDrop1} gameStatePlaced={gameState?.placed} updateDropPosition={updateDropPosition} />
                <Token x={150} y={50} n={1} dropDataSetter={setDrop2} gameStatePlaced={gameState?.placed} updateDropPosition={updateDropPosition} />
                <Token x={250} y={50} n={2} dropDataSetter={setDrop3} gameStatePlaced={gameState?.placed} updateDropPosition={updateDropPosition} />
                <Token x={50} y={150} n={3} dropDataSetter={setDrop4} gameStatePlaced={gameState?.placed} updateDropPosition={updateDropPosition} />
                <Token x={150} y={150} n={4} dropDataSetter={setDrop5} gameStatePlaced={gameState?.placed} updateDropPosition={updateDropPosition} />
                <Token x={250} y={150} n={5} dropDataSetter={setDrop6} gameStatePlaced={gameState?.placed} updateDropPosition={updateDropPosition} />
                <Token x={50} y={250} n={6} dropDataSetter={setDrop7} gameStatePlaced={gameState?.placed} updateDropPosition={updateDropPosition} />
                <Token x={150} y={250} n={7} dropDataSetter={setDrop8} gameStatePlaced={gameState?.placed} updateDropPosition={updateDropPosition} />
                <Token x={250} y={250} n={8} dropDataSetter={setDrop9} gameStatePlaced={gameState?.placed} updateDropPosition={updateDropPosition} />
              </svg>
            </div>
            <Card bg="dark" className="text-center"><Card.Body>
              <SmallToken n={1} evalDrop={evalDrop} disabled={tokenDisabled === undefined ? false : tokenDisabled[0]} setUpdateDropPosition={setUpdateDropPosition} />
              <SmallToken n={2} evalDrop={evalDrop} disabled={tokenDisabled === undefined ? false : tokenDisabled[1]} setUpdateDropPosition={setUpdateDropPosition} />
              <SmallToken n={3} evalDrop={evalDrop} disabled={tokenDisabled === undefined ? false : tokenDisabled[2]} setUpdateDropPosition={setUpdateDropPosition} />
              <SmallToken n={4} evalDrop={evalDrop} disabled={tokenDisabled === undefined ? false : tokenDisabled[3]} setUpdateDropPosition={setUpdateDropPosition} />
              <SmallToken n={5} evalDrop={evalDrop} disabled={tokenDisabled === undefined ? false : tokenDisabled[4]} setUpdateDropPosition={setUpdateDropPosition} />
              <SmallToken n={6} evalDrop={evalDrop} disabled={tokenDisabled === undefined ? false : tokenDisabled[5]} setUpdateDropPosition={setUpdateDropPosition} />
              <SmallToken n={7} evalDrop={evalDrop} disabled={tokenDisabled === undefined ? false : tokenDisabled[6]} setUpdateDropPosition={setUpdateDropPosition} />
              <SmallToken n={8} evalDrop={evalDrop} disabled={tokenDisabled === undefined ? false : tokenDisabled[7]} setUpdateDropPosition={setUpdateDropPosition} />
              <SmallToken n={9} evalDrop={evalDrop} disabled={tokenDisabled === undefined ? false : tokenDisabled[8]} setUpdateDropPosition={setUpdateDropPosition} />
            </Card.Body></Card>
          </Col>
          <Col xs={0} md={1} lg={2} />
        </Row>
      </Container>
    </>
  );
}

//#region GameEndModal
interface GameEndModalProps {
  visible: boolean;
  msg: string;
}

const GameEndModal: React.FC<GameEndModalProps> = ({ visible, msg }) => {
  return (
    <>
      <Modal show={visible}>
        <Modal.Header>
          <Modal.Title>advanded tic tac toe</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{msg}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="info" as={Link} to="/">back to main page</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
//#endregion GameEndModal

//#region Token
interface TokenProps {
  x: number;
  y: number;
  n: number;
  gameStatePlaced: any;
  dropDataSetter: any;
  updateDropPosition: any
}

const Token: React.FC<TokenProps> = ({ x, y, n, gameStatePlaced, dropDataSetter, updateDropPosition }) => {

  var r1: any;

  const [enemy, setEnemy] = useState<boolean | undefined>(undefined);
  const [label, setLabel] = useState<string | undefined>(undefined);

  useEffect(() => {

    if (!updateDropPosition) return;

    if (r1 === undefined) return;

    dropDataSetter({
      id: n,
      x: Math.round(r1.x),
      y: Math.round(r1.y),
      x2: Math.round(r1.right),
      y2: Math.round(r1.bottom)
    });

  }, [updateDropPosition]);

  useEffect(() => {

    if (gameStatePlaced === undefined || gameStatePlaced[n] === undefined) {
      setEnemy(undefined);
      setLabel(undefined);
      return;
    }

    setEnemy(gameStatePlaced[n]?.enemy);
    setLabel(gameStatePlaced[n]?.token);

  }, [gameStatePlaced]);

  return (
    <>
      <text x={x} y={y} textAnchor="middle" dominantBaseline="middle" style={{ userSelect: "none", font: "bold 30px sans-serif" }}>{label}</text>
      <circle ref={r => {
        if (!r) return;
        r1 = r.getBoundingClientRect();
      }} cx={x} cy={y} r="35" strokeWidth="5" fill="none" stroke={((label === undefined) ? undefined : (enemy === true ? "#b30000" : "#0047b3"))} />
    </>
  );
}
//#endregion Token

//#region SmallToken
interface SmallTokenProps {
  n: number;
  enemy?: boolean;
  evalDrop: any;
  disabled?: boolean;
  setUpdateDropPosition: any;
}

const SmallToken: React.FC<SmallTokenProps> = ({ n, enemy, evalDrop, disabled, setUpdateDropPosition }) => {

  function onStart() {
    console.log("drag started"); // TODO: remove DEBUG
    setUpdateDropPosition(true);
  }

  function onDrop(e: any) {
    console.log("drag stopped"); // TODO: remove DEBUG
    evalDrop(e.clientX, e.clientY, n);
  }

  return (
    <Draggable defaultPosition={{ x: 0, y: 0 }} position={{ x: 0, y: 0 }} onStart={onStart} onStop={onDrop} disabled={disabled}>
      <svg width="75" height="75" >
        <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" style={{ userSelect: "none", font: "bold 30px sans-serif" }}>{n}</text>
        <circle cx="50%" cy="50%" r="30" strokeWidth="5" fill="none" stroke={(disabled ? "#595959" : (enemy ? "#b30000" : "#0047b3"))} />
      </svg>
    </Draggable>
  );
}
//#endregion SmallToken
